import { render } from "./DefaultButton.vue?vue&type=template&id=343afe78&scoped=true&ts=true"
import script from "./DefaultButton.vue?vue&type=script&lang=ts"
export * from "./DefaultButton.vue?vue&type=script&lang=ts"

import "./DefaultButton.vue?vue&type=style&index=0&id=343afe78&scoped=true&lang=scss"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343afe78"]])

export default __exports__